export default {"src":"/_next/static/media/lifting.c6f9d31a.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};